import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { beginPerfPageTrace, finalizePerfPageTrace, flushPerfPageTrace } from '@/lib/perf-trace';

export function PagePerformanceTracer() {
  const location = useLocation();
  const route = `${location.pathname}${location.search}`;

  useEffect(() => {
    beginPerfPageTrace(route);
    return () => {
      finalizePerfPageTrace('route-change');
    };
  }, [route]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        flushPerfPageTrace('visibility-hidden');
      }
    };
    const handlePageHide = () => finalizePerfPageTrace('pagehide');

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', handlePageHide);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, []);

  return null;
}
